module.exports = __webpack_public_path__ + "assets/img/w_d_i_3.afca00b1.jpg";